/* Second Bloom — floating tab bar + the one browse window it shares with the header ☰ (mobile only) */
(function () {
  if (customElements.get('sb-mobile-nav')) return;
  var MQ = window.matchMedia('(max-width: 749px)');

  function cartRoute() {
    return (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  }
  function cartDrawer() {
    var d = document.getElementById('Cart-Drawer');
    return d && typeof d.open === 'function' ? d : null;
  }

  // Phones: keep the header in the page flow. The store's custom head script pins it on scroll;
  // marking it as already set up stops that script (it runs at DOMContentLoaded, after this deferred file).
  if (MQ.matches) {
    var hdr = document.querySelector('[class*="ai-custom-header-"]');
    if (hdr) hdr.__stickyInit = true;
  }

  // Tell listeners when any script changes the cart (quick add, drawer qty, product page).
  if (!window.__sbFetchPatched) {
    window.__sbFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { document.dispatchEvent(new CustomEvent('sb:cart-changed')); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  class SBMobileNav extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-sb-tabbar]');
      this.browse = this.querySelector('[data-sb-browse]');
      this.shopItem = this.querySelector('[data-sb-open="shop"]');
      this.cartBadge = this.querySelector('[data-sb-cart-count]');
      this.savedBadge = this.querySelector('[data-sb-saved-count]');
      this.compactOn = this.dataset.compact !== 'false';
      this.fallbackReveal = parseInt(this.dataset.reveal || '120', 10);
      this.isOpen = false;
      this.isShown = false;
      this.settling = false;
      this.lastY = window.scrollY;
      this.ticking = false;
      document.documentElement.classList.add('sbn-nav-on');
      document.body && document.body.classList.add('sbn-nav-on');

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', () => { this.reveal = null; this.update(); }, { passive: true });

      this.addEventListener('click', (e) => this.onClick(e));
      document.addEventListener('click', (e) => this.onHeaderClick(e), true);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });

      var refresh = this.debounce(() => this.refreshCart(), 150);
      ['sb:cart-changed', 'cart:item-added', 'line-item:change:end', 'cart:refresh', 'cart:updated'].forEach(function (n) {
        document.addEventListener(n, refresh);
      });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

      window.addEventListener('pageshow', (e) => {
        if (e.persisted) { this.close(true); this.refreshCart(); this.renderSaved(); }
      });
      document.addEventListener('sb:favourites-changed', () => this.renderSaved());
      window.addEventListener('storage', () => this.renderSaved());
      this.footerRoom();
      this.headerHeart();
      this.renderSaved();
      this.update();
    }

    // A Saved heart in the phone header, just left of the cart, so it is reachable without
    // scrolling far enough for the tab bar to slide in. The theme keeps its desktop and phone
    // headers as separate markup and shows one at a time, so this never doubles up with the
    // desktop heart that sits beside Search.
    headerHeart() {
      var right = document.querySelector('[class*="ai-mobile-right-"]');
      if (!right) return;
      // Normally the section has already drawn it during parsing, so the page paints with it
      // in place. Adopt that one; only build a fresh heart if it is somehow missing.
      var already = right.querySelector('.sbn-hdr-saved');
      if (already) {
        this.headerBadge = already.querySelector('.sbn-hdr-badge');
        return;
      }
      var cart = right.querySelector('[class*="ai-header-cart-wrapper-"]');
      var icon = right.querySelector('a[class*="ai-header-icon-"]');
      var tab = this.querySelector('a.sbn-tabbar__item[href*="/pages/"]');
      var a = document.createElement('a');
      a.href = tab ? tab.getAttribute('href') : '/pages/saved';
      // Borrowing the theme's own icon class keeps the size and stroke matched to the cart.
      a.className = (icon ? icon.className + ' ' : '') + 'sbn-hdr-saved';
      a.setAttribute('aria-label', 'Saved');
      a.style.marginLeft = '0';
      a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round" aria-hidden="true"><path d="M12 20c-1.2 0-9-5-9-10.6C3 6.5 5.1 4.5 7.6 4.5c1.9 0 3.4 1.1 4.4 2.6 1-1.5 2.5-2.6 4.4-2.6 2.5 0 4.6 2 4.6 4.9C21 15 13.2 20 12 20z"/></svg><span class="sbn-hdr-badge" hidden></span>';
      if (location.pathname === a.getAttribute('href')) a.classList.add('is-current');
      if (cart) right.insertBefore(a, cart);
      else right.appendChild(a);
      this.headerBadge = a.querySelector('.sbn-hdr-badge');
    }

    // The floating bar needs clear space under the page, but putting it on the white wrapper
    // left a pale band below the dark footer. Move that space inside the footer instead, and
    // carry the footer's own colour onto its section so it runs right to the bottom.
    footerRoom() {
      if (!MQ.matches) return;
      var room = 'calc(88px + env(safe-area-inset-bottom))';
      var wrap = document.getElementById('wrapper');
      if (wrap) wrap.style.paddingBottom = '0px';
      var group = document.querySelector('.shopify-section-group-footer-group');
      if (!group) return;
      var inner = group.lastElementChild;
      if (inner) {
        // Read the colour off whichever element actually carries it, rather than assuming.
        var paint = window.getComputedStyle(inner).backgroundColor;
        if (paint && paint !== 'transparent' && paint.indexOf('rgba(0, 0, 0, 0)') === -1) {
          group.style.backgroundColor = paint;
        }
      }
      group.style.paddingBottom = room;
    }

    debounce(fn, wait) {
      var t;
      return function () { clearTimeout(t); t = setTimeout(fn, wait); };
    }

    revealPoint() {
      if (this.reveal != null) return this.reveal;
      var header = document.querySelector('[class*="ai-custom-header-"]');
      var bottom = header ? header.getBoundingClientRect().bottom + window.scrollY : 0;
      this.reveal = Math.max(bottom, 40) || this.fallbackReveal;
      return this.reveal;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => { this.ticking = false; this.update(); });
    }

    update() {
      if (!MQ.matches) return;
      var y = window.scrollY;
      var shown = this.isOpen || y > this.revealPoint();

      // Sliding in and resizing at the same moment reads as two separate movements, which is what
      // made the bar look like it was being switched on rather than arriving. So while it travels,
      // its size is held: full size on the way in, whatever it had on the way out.
      if (shown !== this.isShown) {
        this.isShown = shown;
        this.classList.toggle('is-shown', shown);
        clearTimeout(this.idle);
        clearTimeout(this.sizeHold);
        this.settling = true;
        if (shown) this.classList.remove('is-compact');
        this.sizeHold = setTimeout(() => {
          this.settling = false;
          if (!this.isShown) this.classList.remove('is-compact');
        }, 460);
        this.lastY = y;
        return;
      }

      if (this.compactOn && shown && !this.isOpen && !this.settling) {
        if (y > this.lastY + 2) this.classList.add('is-compact');
        else if (y < this.lastY - 2) this.classList.remove('is-compact');
        clearTimeout(this.idle);
        this.idle = setTimeout(() => this.classList.remove('is-compact'), 450);
      } else if (!shown && !this.settling) {
        this.classList.remove('is-compact');
      }
      this.lastY = y;
    }

    onClick(e) {
      var open = e.target.closest('[data-sb-open]');
      if (open) {
        e.preventDefault();
        if (this.isOpen) this.close();
        else this.open();
        return;
      }
      if (e.target.closest('[data-sb-close]')) { e.preventDefault(); this.close(); return; }
      var cart = e.target.closest('[data-sb-cart]');
      if (cart) {
        var d = cartDrawer();
        if (d) { e.preventDefault(); this.close(); d.open(); }
        return;
      }
      // Other links inside the window: keep the window up while the next page loads, so the old page
      // never flashes in between. It is reset on pageshow if the shopper comes back with the Back button.
    }

    onHeaderClick(e) {
      if (!MQ.matches) return;
      var trigger = e.target.closest('[class*="ai-mobile-menu-trigger-"]');
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open();
        return;
      }
      var headerCart = e.target.closest('[class*="ai-header-cart-wrapper-"] a');
      if (headerCart) {
        var d = cartDrawer();
        if (d) { e.preventDefault(); e.stopImmediatePropagation(); d.open(); }
      }
    }

    open() {
      if (!this.browse) return;
      this.lastFocus = document.activeElement;
      this.isOpen = true;
      this.browse.hidden = false;
      // One list, always from the top — whether it was opened from the Shop tab or the ☰.
      var scroller = this.browse.querySelector('.sbn-browse__scroll');
      if (scroller) scroller.scrollTop = 0;
      if (this.shopItem) this.shopItem.classList.add('is-active');
      document.documentElement.classList.add('sbn-lock');
      requestAnimationFrame(() => this.browse.classList.add('is-open'));
      this.classList.add('is-browsing');
      this.update();
      var close = this.browse.querySelector('[data-sb-close]');
      if (close) close.focus({ preventScroll: true });
    }

    close(instant) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.browse.classList.remove('is-open');
      document.documentElement.classList.remove('sbn-lock');
      this.classList.remove('is-browsing');
      if (this.shopItem) this.shopItem.classList.remove('is-active');
      var hide = () => { if (!this.isOpen) this.browse.hidden = true; };
      if (instant) hide(); else setTimeout(hide, 260);
      if (this.lastFocus && this.lastFocus.focus && !instant) this.lastFocus.focus({ preventScroll: true });
      this.update();
    }

    refreshCart() {
      if (!this.cartBadge) return;
      fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((c) => {
          var n = c && typeof c.item_count === 'number' ? c.item_count : 0;
          this.cartBadge.textContent = n;
          this.cartBadge.hidden = n === 0;
          var cartItem = this.querySelector('[data-sb-cart]');
          if (cartItem) cartItem.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
        })
        .catch(function () {});
    }

    renderSaved() {
      var n = window.SBFav ? window.SBFav.count() : 0;
      [this.savedBadge, this.headerBadge].forEach(function (b) {
        if (!b) return;
        b.textContent = n;
        b.hidden = n === 0;
      });
    }
  }

  customElements.define('sb-mobile-nav', SBMobileNav);
})();